// import categoriesWatcher from "./Categories/Watcher";
import testPaperWatcher from "./TestPapers/Watcher";

export function* watchers(): any {
  // yield productsWatcher();
  // yield categoriesWatcher();
  yield testPaperWatcher();
}
